export default __webpack_public_path__ + "static/media/wig.3dbc28f5.svg";